import './devbx.webform.popup.message.css';

BX.addCustomEvent("DevBxWebFormCreated", function(app) {
    app.component('devbx-webform-popup-message', {
        props: {
            message: {
                type: String,
                required: true,
            }
        },
        emits: ['close'],
        data() {
            return {
                popupStyle: {
                    top: '-100px',
                }
            }
        },
        mounted()
        {
            document.body.appendChild(this.$el);

            let self = this;

            setTimeout(function() {
                self.popupStyle.top = '20px';
            }, 0);
        },
        template: `
        <div class="devbx-webform-theme devbx-webform-popup-message" :style="popupStyle">
            <div class="devbx-webform-popup-content" v-html="message"></div>
            <div class="devbx-webform-popup-close" @click.stop.prevent="$emit('close')">
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="devbx-webform-popup-close-icon">
    <g id="close">
        <path id="x" d="M18.717 6.697l-1.414-1.414-5.303 5.303-5.303-5.303-1.414 1.414 5.303 5.303-5.303 5.303 1.414 1.414 5.303-5.303 5.303 5.303 1.414-1.414-5.303-5.303z"/>
    </g>
</svg>            
            </div>            
        </div>
        `
    });
});
